import styled from "styled-components";

const Gaps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export default Gaps;
